// ProductReviewWrapper.tsx
import React from "react";
import ProductReviewCard from "./ProductReviewCard";
import "./ProductReviewWrapper.css";

interface Review {
  review_text: string;
}

interface ProductReview {
  sku: string;
  total_reviews: number;
  total_score: number;
  reviews: Review[];
}

interface ReviewResponse {
  intro: string;
  review_products: ProductReview[];
  conclusion: string;
}

interface ProductReviewWrapperProps {
  reviewData: ReviewResponse;
}

const ProductReviewWrapper: React.FC<ProductReviewWrapperProps> = ({ reviewData }) => {
  return (
    <div className="product-review-wrapper">
      {reviewData.intro && (
        <div className="review-intro">
          <p>{reviewData.intro}</p>
        </div>
      )}

      {reviewData.review_products && reviewData.review_products.length > 0 ? (
        reviewData.review_products.map((productReview) => (
          <ProductReviewCard
            key={productReview.sku}
            sku={productReview.sku}
            totalReviews={productReview.total_reviews}
            totalScore={productReview.total_score}
            reviews={productReview.reviews}
          />
        ))
      ) : (
        <p className="no-reviews">Δεν υπάρχουν διαθέσιμες κριτικές.</p>
      )}

      {reviewData.conclusion && (
        <div className="review-conclusion">
          <p>{reviewData.conclusion}</p>
        </div>
      )}
    </div>
  );
};

export default ProductReviewWrapper;
